// extracted by mini-css-extract-plugin
export default {"productGallery":"zH-z","inQuickShop":"AH-z"};